import { trackingAxios } from 'config/api/tracking'
import { IOrderRepository, OrderFilters } from 'orders/domain/repositories/IOrderRepository'
import { OrderListEntity, OrderSummaryEntity } from 'orders/domain/entities/order.entity'
import { OrderAdapter } from 'orders/infrastructure/adapters/OrderAdapter'

export class OrderHttpRepository implements IOrderRepository {
    async list(filters: OrderFilters): Promise<OrderListEntity> {
        try {
            // Omit null/undefined/'' so the backend distinguishes
            // true / false / absent (SM-1119: omitir = no filtrar).
            const params = Object.fromEntries(
                Object.entries(filters).filter(
                    ([, value]) => value !== null && value !== undefined && value !== ''
                )
            )
            const response = await trackingAxios.get('/orders', { params })
            return OrderAdapter.toDomainList(response.data)
        } catch (error) {
            console.error('[OrderHttpRepository] Error fetching orders list:', error)
            throw error
        }
    }

    async summary(): Promise<OrderSummaryEntity> {
        try {
            const response = await trackingAxios.get('/orders/summary')
            return OrderAdapter.toDomainSummary(response.data)
        } catch (error) {
            console.error('[OrderHttpRepository] Error fetching orders summary:', error)
            throw error
        }
    }
}
